
export default {
  auth: false,
  methods: {
    register() {
      //
    },
  },
};
